// @ts-nocheck
import { OrderChangeRequestModel } from "@insite/client-framework/Types/ApiModels";
import {
    GetOrderChangeRequestApiParameter,
    sendOrderChangeRequestEmail,
} from "@store/Framework/Services/OrderChangeRequestService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = OrderChangeRequestModel & HasOnError;
type HandlerType = ApiHandlerDiscreteParameter<Parameter, GetOrderChangeRequestApiParameter, OrderChangeRequestModel>;

export const DispatchBeginSubmitRequest: HandlerType = props => {
    props.dispatch({
        type: "Greif/PagesReducer/RequestOrderChange/BeginSubmitRequest",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        orderChangeRequestParameter: props.parameter,
    };
};

export const SubmitRequest: HandlerType = async props => {
    const result = await sendOrderChangeRequestEmail(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        props.parameter.onError?.();
        props.dispatch({
            type: "Greif/PagesReducer/RequestOrderChange/FailedToSubmitRequest",
            errorMessage: result.errorMessage,
        });
        return false;
    }
};

export const DispatchCompleteSubmitRequest: HandlerType = props => {
    props.dispatch({
        type: "Greif/PagesReducer/RequestOrderChange/CompleteSubmitRequest",
    });
};

export const chain = [DispatchBeginSubmitRequest, PopulateApiParameter, SubmitRequest, DispatchCompleteSubmitRequest];

const submitRequestOrderChange = createHandlerChainRunner(chain, "SubmitRequestOrderChange");
export default submitRequestOrderChange;
